import { HeadProps, PageProps, graphql } from 'gatsby'
import { Fragment } from 'react'

import { Seo } from '@/features/common/'
import { NewsGrid } from '@/features/news'
import { PageHero } from '@/features/page-sections'

const NewsPage = ({
  data: { datoCmsNewsPage: page },
}: PageProps<Queries.NewsPageQuery>): JSX.Element => {
  return (
    <Fragment>
      <PageHero
        heading={page?.pageHeading}
        heroImage={page?.heroImage}
      />
      <NewsGrid />
    </Fragment>
  )
}

export const Head = ({
  data: { datoCmsNewsPage: page },
}: HeadProps<Queries.NewsPageQuery>) => (
  <Seo seoMetaTags={page?.seoMetaTags} />
)

export const data = graphql`
  query NewsPage {
    datoCmsNewsPage {
      pageHeading
      heroImage {
        ...PageHero
      }
      seoMetaTags {
        tags
      }
    }
  }
`

export default NewsPage
